// extracted by mini-css-extract-plugin
export default {"desktopFix":"index_desktopFix_82NYj"};